import React from 'react';
import styles from './navbar.module.css'

const Navbar = () => {
    const date = new Date();
    console.log(date);
    console.log(date.getDate(),date.getDay)

    return (
        <header className={styles.header}>
            <p>{`${date.getFullYear()}년 ${date.getMonth()+1}월 ${date.getDate()}일`}</p>
            <h1 className={styles.header_text}>오늘의 할일!</h1>
        </header>
    );
};

export default Navbar;